import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '@pnl/ui';
import { useAuthStore } from './auth.store';

export function AuthGuard() {
  const status = useAuthStore((s) => s.status);
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const location = useLocation();

  useEffect(() => {
    if (status === 'unknown') void bootstrap();
  }, [status, bootstrap]);

  if (status === 'unknown' || status === 'loading') {
    return (
      <div className="bg-ink-950 flex min-h-screen items-center justify-center">
        <Spinner size={28} />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
